// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-color)] p-5">
      <Helmet>
        <title>Page Not Found | Hari Vishnu</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="text-center max-w-[600px] mx-auto">
        <div className="mb-8">
          <h1 className="text-[6rem] font-bold text-[var(--post-heading-font)] m-0 leading-none">404</h1>
          <div className="error-icon text-[4rem] mt-4"><span role="img" aria-label="magnifying glass">🔍</span></div>
        </div>

        <div>
          <h2 className="text-[var(--post-heading-font)] mb-4 text-2xl">Oops! Page Not Found</h2>
          <p className="text-[var(--post-content-font)] text-[1.1rem] leading-relaxed mb-8">
            The page you're looking for seems to have wandered off into the digital void.
            Don't worry, even the best explorers sometimes take a wrong turn!
          </p>

          <div className="bg-[var(--hover-color)] p-6 rounded-lg my-8 text-left">
            <h3 className="text-[var(--post-heading-font)] mb-4 text-center">Here are some helpful links:</h3>
            <ul className="list-none p-0 m-0">
              <li className="my-2"><Link to="/" className="text-[var(--post-heading-font)] no-underline font-medium transition-colors duration-300 hover:text-[#3a9bdb] hover:underline"><span role="img" aria-label="house">🏠</span> Home</Link></li>
              <li className="my-2"><Link to="/blog" className="text-[var(--post-heading-font)] no-underline font-medium transition-colors duration-300 hover:text-[#3a9bdb] hover:underline"><span role="img" aria-label="memo">📝</span> Blog</Link></li>
              <li className="my-2"><Link to="/store" className="text-[var(--post-heading-font)] no-underline font-medium transition-colors duration-300 hover:text-[#3a9bdb] hover:underline"><span role="img" aria-label="shopping bags">🛍️</span> Store</Link></li>
              <li className="my-2"><Link to="/contact" className="text-[var(--post-heading-font)] no-underline font-medium transition-colors duration-300 hover:text-[#3a9bdb] hover:underline"><span role="img" aria-label="email">📧</span> Contact</Link></li>
            </ul>
          </div>

          <div className="mt-8">
            <p className="mb-4 text-[var(--post-content-font)]">Or try searching for what you need:</p>
            <div className="flex gap-[10px] max-w-[400px] mx-auto">
              <input
                type="text"
                placeholder="Search for articles, products, or topics..."
                className="flex-1 px-4 py-3 border-2 border-[var(--slider-color)] rounded-lg text-base outline-none transition-colors duration-300 focus:border-[#3a9bdb]"
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    window.location.href = `/search?q=${encodeURIComponent(e.target.value)}`;
                  }
                }}
              />
              <button
                onClick={() => {
                  const input = document.querySelector('.search-box input');
                  if (input && (input as HTMLInputElement).value.trim()) {
                    window.location.href = `/search?q=${encodeURIComponent((input as HTMLInputElement).value)}`;
                  }
                }}
                className="px-6 py-3 bg-[var(--post-heading-font)] text-white border-none rounded-lg cursor-pointer font-medium transition-colors duration-300 hover:bg-[#3a9bdb]"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
